import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_7: FaireProductEntity = {
  token: "casa-bosques-7",
  type: "product",
  name: "Sardinha Green Package",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2a6ca115955ee7fa0eb159e8c05c4d0b6e9cdaeef8fa05a6b8d467e6dc39cd09.webp",
  priceDollars: 12,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
